
import Vue from "vue"
import Component from "vue-class-component"
import {Model, Prop} from "vue-property-decorator"
import Multiselect from "vue-multiselect"
import {highlightText} from "@/utils/highlightText"
import {Option} from "@/ui/Option"

/**
 * Quasar q-select search usability is not very good, so Vue-multiselect is
 * used to provide a standard select functionality with search.
 * Application shouldn't use Multiselect directly, but rely on the this
 * component functionality
 */
@Component({components: {Multiselect}})
export default class OptionSelect extends Vue {
  @Model("input")
  readonly selected: Array<unknown> | unknown

  @Prop({required: true})
  options: Array<Option>

  @Prop({default: () => []})
  disabledValues: Array<string>

  @Prop()
  selectedRender: (selection: Array<Option> | Option) => string

  syncSelected: Array<Option> | Option = <any>null

  optionsByLabel: Map<string, Option>
  optionsByValue: Map<any, Option>

  created() {
    this.$watch(
      () => this.selected,
      (newSelection, oldSelection) => {
        console.log("Selection watch", newSelection, oldSelection)
        this.syncSelected = this.toOption(newSelection)
      }
    )

    const optionsMap = this.options.reduce(
      ({byLabel, byValue}, option) => {
        byLabel.set(option.label, option)
        byValue.set(option.value, option)
        return {byLabel, byValue}
      },
      {byLabel: new Map(), byValue: new Map()}
    )

    this.optionsByLabel = optionsMap.byLabel
    this.optionsByValue = optionsMap.byValue

    console.log("this.optionsByValue", this.optionsByValue)
    console.log("this.selected", this.selected)
    this.syncSelected = this.toOption(this.selected)

    console.log("this.syncSelected", this.syncSelected)
  }

  get filteredOptions() {
    return this.options.map(option =>
      this.disabledValues.includes(option.value) ? {...option, $isDisabled: true} : option
    )
  }

  setSelected(selection: Array<Option> | Option) {
    const emitValue = Array.isArray(selection)
      ? selection.map(option => option.value)
      : selection.value

    this.$emit("input", emitValue)
    this.syncSelected = selection
  }

  clearSelected() {
    this.setSelected([])
  }

  private highlight(label: string, search: string) {
    return search === "" ? label : highlightText(label, search, "strong")
  }

  private toOption(selection: unknown | Array<unknown>) {
    return Array.isArray(selection)
      ? selection.map(value => this.optionsByValue.get(value)!)
      : this.optionsByValue.get(selection)!
  }
}
